import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux'; // connects Redux store with React
// import configureStore from './store/configureStore';
import store from './store/configureStore';
import App from './App';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import './index.css';

// const store = configureStore();
// var location = window.location; 
render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);

// The CRA service worker precached the app shell, so a deployed change only
// reached people on the visit *after* the next one - and only once every tab
// had been closed. For an app people leave open all day, and that pops chat out
// into separate windows, that could hold someone on an old build for days; it
// is why a deploy needed a hard reload to show up. Nothing here works offline
// regardless: it needs the API and the SignalR hub to do anything at all.
//
// This also takes the worker off machines that installed it before this change.
unregisterServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js